import dayjs from "dayjs";

// 计算上周第一天和最后一天
export function lastWeek() {
  let obj = {
    startOf: dayjs().add(-1, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD'),
    endOf: dayjs().add(-1, 'week').endOf('week').add(1, 'day').format('YYYY-MM-DD'),
  };
  return obj;
}
